module.exports = __webpack_public_path__ + "img/translate-fourteen.d8866187.png";